import React,{useState} from 'react'
import {
  Form,
  FormGroup,
  Label,
  Input,
  Container
} from 'reactstrap'
import Layout from '../Layout/Layout'
import PageHeader from '../PageHeader/PageHeader'
import Button from '../Button/Button'

export const disclaimerVersion = 'Dream Exchange Connect.7.13.2020'

const Disclaimer = props => {
  const [iAgree, setIAgree] = useState(false)
  const [dontShowAgain, setDontShowAgain] = useState(false)

  function agree(checked) {
    setIAgree(checked)
  }

  function dontShow(checked) {
    setDontShowAgain(checked)
  }

  function submit() {
    props.submit(iAgree, dontShowAgain)
  }

  return (
    <Layout product='none'>
      <PageHeader title='DreamEx Connect Disclaimer'>
      <Container style={{margin: '40px'}}>
      <div >
        <h1>GENERAL DISCLAIMERS</h1>
        <p>
        DreamEx Connect provides a vehicle in which a company can publish detailed information, including descriptions of services and products provided by the company, its ownership structure, and whether the company is considering a private equity or debt transaction.  The DreamEx Connect platform also facilitates investors who may have an interest in learning more about specific companies, including companies that desire to engage in a private transaction. DreamEx Connect is not an investment advisory service, a registered investment adviser, a broker-dealer, a stock or futures exchange, or an exchange of any type.  DreamEx Connect does not propose to tell or suggest or recommend which business interest investors should buy or sell for themselves.  DreamEx Connect, its executives, employees, and third-party service providers and all other affiliates assume no responsibility for liability from any trading, investment or business results. Factual statements on the DreamEx Connect platform, and any related website, correspondence, or publications (the “platform”), are made as of the date stated and are subject to change without notice.   
        </p>
        <p>
        The platform and its content presented are to be used for informational purposes only.  DreamEx Connect cannot and does not assess, verify, or guarantee the adequacy, accuracy, or completeness of any information, the suitability or profitability of any particular investment or business interest, or the potential value of any investment or information source.  You are responsible for conducting your own investment research and decisions, and should seek the advice of a business evaluator and/or a qualified securities professional before making any investment or business purchase, and investigate and fully understand any and all risks, before investing, and that are part of the business interest.  DreamEx Connect in no way warrants to solvency, financial conditions, or investment advisability of any of the businesses presented on its platform.   
        </p>
        <p>
        Nothing on this platform should be construed as, and may not be used in connection with, an offer to sell, or a solicitation of an offer to buy or hold, an interest in any security, business entity, company, intellectual property, or investment product. 
        </p>

        <h1>FORWARD-LOOKING STATEMENTS</h1>
        <p>
        Some information contained in the platform may constitute “forward-looking” information within the meaning of applicable securities laws, and is made solely by the company using the platform.  Forward-looking statements are provided to allow potential investors the opportunity to understand a company’s management’s belief and opinions in respect of the future so that they may use such beliefs and opinion as one factor in evaluating an investment.  DreamEx Connect has no responsibility over the use of forward-looking statements or the responsibility to identify such statements. 
        </p>

        <h1>AS IS BASIS</h1>
        <p>
        YOU EXPRESSLY UNDERSTAND AND AGREE THAT:
        </p>
        <p>
        YOUR USE OF THE PLATFORM IS PROVIDED ON AN “AS IS” AND “AS AVAILABLE BASIS.” TO THE FULL EXTENT PREMITTED UNDER APPLICABLE LAW, DREAM EXCHANGE EXPRESSLY DISCLAIMS ALL WARRANTIES OF ANY KIND WITH RESPECT TO THE PLATFORM AND ANY PRODUCTS OR SERVICES AVAILABLE ON OR THROUGH THE PLATFORM, WHETHER EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OR MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NON-INFRINGEMENT.  
        </p>
        <p>
        DREAM EXCHANGE MAKES NO WARRANTY THAT (1) THE PLATFORM OR ANY PRODUCTS, SERVICES, CONTENT, INFORMATION OR OTHER MATERIAL OBTAINED THROUGH THE PLATFORM WILL MEET YOUR REQUIREMENTS OR EXPECTATIONS; (2) THE CONTENT, DATA AND MATERIALS PRESENTED OR DISPLAYED ON THE PLATFORM ARE CORRECT, ACCURATE OR RELIABLE; (3) THE FUNCTIONS AND CONTENT CONTAINED IN OR ON THE PLATFORM WILL BE WITHOUT ERRORS; (4) THE PLATFORM WILL BE FREE OF VIRUSES; (5) THAT THE SECURITY MEASURES TAKEN BY DREAM EXCHANGE TO PROTECT USERS WILL WITHSTAND ATTEMPTS TO EVADE SECURITY MACHANISMS OR THAT THERE WILL BE NO CRACKS, DISABLEMENTS OR OTHER CIRCUMVENTION OF SUCH SECURITY MEASURES; OR THAT ANY PLATFORM DEFECTS WILL BE CORRECTED, EVEN IF DREAM EXCHANGE IS AWARE OF THEM.
        </p>
        <h1>LIMITS ON LIABILITY</h1>
        <p>
        TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT WILL DREAM EXCHANGE, ITS AFFILIATES OR THEIR RESPECTIVE OFFICERS, DIRECTORS, MANAGERS, EMPLOYEES OR AGENTS BE LIABLE FOR ANY DAMAGES, INCLUDING, WITHOUT LIMITATION, DIRECT, INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL OR PUNITIVE DAMAGES, WHETHER UNDER CONTRACT, TORT OR ANY OTHER THEORY OF LIABILITY, ARISING IN CONNECTION WITH (1) THE USE OF THE PLATFORM; (2) ANY FAILURE, ERROR, OMISSION, INTERRUPTION, DEFECT DELAY, COMPUTER VIRUS OR LOSS OF DATA; (3) ANY LOSS OF USE RELATED TO THE PLATFORM OR A LINKED SITE; (4) ANY DATA OR CONTENT ON THE WEBSITE OR A LINKED SITE, INCLUDING WITHOUT LIMITATION ANY DAMAGES CAUSED BY OR RESULTING FROM RELIANCE BY YOU ON ANY INFORMATION OR CONTENT OBTAINED FROM DREAM EXCHANGE; OR (5) ANY LOSS RELATING TO YOUR INVESTMENTS AND INVESTMENT RESULTS.  
        </p>
      </div>
      <Form>
        <p/>
        <FormGroup check>
          <Label check>
            <Input type='checkbox' value={iAgree} onClick={e => agree(e.target.checked)} />{' '}
            <span style={{fontSize: 'large'}}>I agree to these terms</span>
          </Label>
        </FormGroup>
        <FormGroup check>
          <Label check>
            <Input type='checkbox' value={dontShowAgain} onClick={e => dontShow(e.target.checked)} />{' '}
            <span style={{fontSize: 'large'}}>Do not show this again</span>
          </Label>
        </FormGroup>
        <p/>
        <Button color='blue' click={submit}>SUBMIT</Button>
      </Form>
      </Container>
      </PageHeader>
      </Layout>
  )
}

export default Disclaimer